module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-Regular-Cy-Web.36062afb.woff2";